import { Button, Card, Col, Form, InputNumber, Row, Space, Spin, message } from 'antd';
import { useRequest } from 'ahooks';
import { ReloadOutlined } from '@ant-design/icons';
import { SchedulerStopHourConfig, systemController } from '../../../api';

const FIELDS: { name: keyof SchedulerStopHourConfig; label: string; tooltip: string }[] = [
  {
    name: 'cleanCustomerEventStopHour',
    label: '客户事件清理停止时间',
    tooltip: '凌晨 2 点开始清理客户事件，到达此小时点立即停止',
  },
  {
    name: 'cleanDeletedCustomerEventStopHour',
    label: '已删除客户事件清理停止时间',
    tooltip: '凌晨 1 点开始清理已删除客户事件，到达此小时点立即停止',
  },
  {
    name: 'cleanWechatMessageStopHour',
    label: '微信消息清理停止时间',
    tooltip: '凌晨 2 点开始清理微信消息，到达此小时点立即停止',
  },
  {
    name: 'cleanUserFileStopHour',
    label: '用户文件清理停止时间',
    tooltip: '凌晨 1 点开始清理用户文件及对应 OSS 对象，到达此小时点立即停止',
  },
];

export default function SchedulerStopHourCard() {
  const [form] = Form.useForm<SchedulerStopHourConfig>();

  const { loading: getLoading, refresh } = useRequest(
    () => systemController.getSchedulerStopHourConfig(),
    {
      onSuccess: (data) => {
        form.setFieldsValue(data);
      },
    },
  );

  const { loading: updateLoading, run: update } = useRequest(
    (dto: SchedulerStopHourConfig) => systemController.updateSchedulerStopHourConfig(dto),
    {
      manual: true,
      onSuccess: () => {
        message.success('更新成功');
        refresh();
      },
      onError: (e) => {
        message.error(e.message || '更新失败');
      },
    },
  );

  const handleSave = async () => {
    const values = await form.validateFields();
    update(values);
  };

  return (
    <Card title="定时任务停止时间">
      <Spin spinning={getLoading || updateLoading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            {FIELDS.map((f) => (
              <Col span={12} key={f.name}>
                <Form.Item
                  name={f.name}
                  label={f.label}
                  tooltip={f.tooltip}
                  rules={[
                    {
                      type: 'integer',
                      min: 0,
                      max: 23,
                      message: '必须为 0-23 的整数',
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={23}
                    precision={0}
                    placeholder="默认 7"
                    style={{ width: '100%' }}
                    addonAfter="点"
                  />
                </Form.Item>
              </Col>
            ))}
          </Row>
          <Space>
            <Button type="primary" onClick={handleSave} loading={updateLoading}>
              保存
            </Button>
            <Button icon={<ReloadOutlined />} onClick={refresh}>
              刷新
            </Button>
          </Space>
        </Form>
      </Spin>
    </Card>
  );
}
